import createRoute    from '@widesk-ui/tools/createRoute';
import PromoCodeModel from '@models/shop/PromoCodeModel';

export default createRoute.dashboard('/promo_codes', 'shop', 'PromoCodeDashboard', PromoCodeModel.localize());
